import React, { useState } from "react";
import { Plus, Facebook, Linkedin, Instagram, BarChart2, X } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { faFacebook, faLinkedinIn, faInstagram } from '@fortawesome/free-brands-svg-icons';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
  BarChart, Bar
} from 'recharts';

const campaignsData = [
  { id: 1, name: "Q4 Holiday Sale", status: "Active", platforms: ["facebook", "instagram"], spend: 1250, budget: 2000, clicks: 15430, conversions: 812 },
  { id: 2, name: "New Product Launch", status: "Active", platforms: ["linkedin"], spend: 800, budget: 1500, clicks: 45120, conversions: 312 },
  { id: 3, name: "Campaign Overview", status: "Active", platforms: ["linkedin"], spend: 1200, budget: 3000, clicks: 9120, conversions: 350 },
  { id: 4, name: "Q4 Campaign Overview", status: "Active", platforms: ["facebook", "instagram"], spend: 1800, budget: 5000, clicks: 9120, conversions: 812 },
  { id: 5, name: "Brand Awareness", status: "Active", platforms: ["facebook"], spend: 1500, budget: 2500, clicks: 43790, conversions: 180 },
  { id: 6, name: "Webinar Promotion", status: "Active", platforms: ["linkedin"], spend: 2700, budget: 4000, clicks: 640, conversions: 180 },
];


const getTrendChartData = (campaign) => {
  return [
    { name: 'Week 1', Conversions: Math.round(campaign.conversions * 0.25), Clicks: Math.round(campaign.clicks * 0.1) },
    { name: 'Week 2', Conversions: Math.round(campaign.conversions * 0.5), Clicks: Math.round(campaign.clicks * 0.4) },
    { name: 'Week 3', Conversions: Math.round(campaign.conversions * 0.8), Clicks: Math.round(campaign.clicks * 0.7) },
    { name: 'Week 4', Conversions: campaign.conversions, Clicks: campaign.clicks },
  ];
};
const getBudgetChartData = (campaign) => [{ name: 'Financial Overview', Budget: campaign.budget, Spend: campaign.spend, Remaining: campaign.budget - campaign.spend }];

// ---------------- Campaign Detail Modal (Existing) ----------------
const CampaignDetailModal = ({ campaign, onClose }) => {

  const platforms = campaign?.platforms || [];
  const [selectedPlatform, setSelectedPlatform] = useState(platforms[0] || "");

  if (!campaign) return null; // ✅ Condition after useState

  const trendChartData = getTrendChartData(campaign);
  const budgetChartData = getBudgetChartData(campaign);

  return (
    <div className="create-new-campaign-modal-popup-overlay" onClick={onClose}>
      <div className="create-new-campaign-modal-popup-content" onClick={(e) => e.stopPropagation()}>
        <div className="create-new-campaign-modal-popup-header">
          <h2>{campaign.name} - Detailed Performance Analysis</h2>
          <X size={24} className="create-new-campaign-modal-popup-close" onClick={onClose} />
        </div>

        {/* ✅ Platform Dropdown */}
        <div className="create-new-campaign-deatils-modal-dropdown-box">
          <select
            value={selectedPlatform}
            onChange={(e) => setSelectedPlatform(e.target.value)}
            className="create-new-campaign-dropdown"
            style={{ width: "180px" }}
          >
            {platforms.includes("facebook") && <option value="facebook">Facebook</option>}
            {platforms.includes("instagram") && <option value="instagram">Instagram</option>}
            {platforms.includes("linkedin") && <option value="linkedin">LinkedIn</option>}
          </select>
        </div>

        <div className="create-new-campaign-modal-popup-metrics">
          <p><strong>Platform:</strong> {selectedPlatform.toUpperCase()}</p>
          <p><strong>Status:</strong> <span className={`status-${campaign.status.toLowerCase()}`}>{campaign.status}</span></p>
          <p><strong>Total Spend:</strong> <span className="metric-spend">${campaign.spend.toLocaleString()}</span></p>
          <p><strong>Total Conversions:</strong> <span className="metric-conversions">{campaign.conversions.toLocaleString()}</span></p>
          <p><strong>Clicks (Total):</strong> <span className="metric-clicks">{campaign.clicks.toLocaleString()}</span></p>
        </div>

        <div className="create-new-campaign-modal-popup-chart-container">
          
          {/* Bar Chart */}
          <div className="create-new-campaign-modal-popup-chart-box">
            <h3>Budget Allocation - {selectedPlatform.toUpperCase()}</h3>
            <div className="chart-wrapper">
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={budgetChartData} layout="vertical">
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis type="number" hide />
                  <YAxis type="category" dataKey="name" width={100} />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="Budget" fill="#ad7474ff" name="Total Budget" />
                  <Bar dataKey="Spend" fill="#8884d8" name="Current Spend" />
                      <Bar dataKey="Spend" fill="#84d896ff" name="Remaining Budget" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>

          {/* Line Chart */}
          <div className="create-new-campaign-modal-popup-chart-box">
            <h3>Performance Trend - {selectedPlatform.toUpperCase()}</h3>
            <div className="chart-wrapper">
              <ResponsiveContainer width="100%" height="100%">
                <LineChart data={trendChartData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis yAxisId="conversions" stroke="#82ca9d" />
                  <YAxis yAxisId="clicks" orientation="right" stroke="#ff7300" />
                  <Tooltip />
                  <Legend />
                  <Line yAxisId="conversions" dataKey="Conversions" stroke="#82ca9d" strokeWidth={2} />
                  <Line yAxisId="clicks" dataKey="Clicks" stroke="#ff7300" strokeWidth={2} />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};



// ---------------- NEW: Generate Report Modal (Updated) ----------------
const GenerateReportModal = ({ campaigns, onClose }) => {
 
  const [selectedCampaigns, setSelectedCampaigns] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [reportName, setReportName] = useState("");
  

  const filtered = campaigns; 

  const toggleSelect = (id) => {
    setSelectedCampaigns((prev) =>
      prev.includes(id) ? prev.filter((cid) => cid !== id) : [...prev, id]
    );
  };

  const handleSubmit = () => setSubmitted(true);
  const selectedData = campaigns.filter((c) => selectedCampaigns.includes(c.id));

// inside GenerateReportModal component (above return)
const serializeChartToPngDataUrl = async () => {
  try {
    const container = document.querySelector(".create-new-campaign-modal-popup-genrate-report-chart");
    if (!container) return null;
    const svg = container.querySelector("svg");
    if (!svg) return null;


    const serializer = new XMLSerializer();
    let svgStr = serializer.serializeToString(svg);

    if (!svgStr.match(/^<svg[^>]+xmlns="http:\/\/www\.w3\.org\/2000\/svg"/)) {
      svgStr = svgStr.replace(/^<svg/, '<svg xmlns="http://www.w3.org/2000/svg"');
    }

    // Make blob url from svg string
    const blob = new Blob([svgStr], { type: "image/svg+xml;charset=utf-8" });
    const url = URL.createObjectURL(blob);


    const img = new Image();
    img.crossOrigin = "Anonymous";

    return await new Promise((resolve) => {
      img.onload = () => {
        const canvas = document.createElement("canvas");
  
        canvas.width = img.width || svg.getBoundingClientRect().width || 800;
        canvas.height = img.height || svg.getBoundingClientRect().height || 400;
        const ctx = canvas.getContext("2d");

        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0);
        URL.revokeObjectURL(url);
        resolve(canvas.toDataURL("image/png"));
      };
      img.onerror = () => {
        URL.revokeObjectURL(url);
        resolve(null);
      };
      img.src = url;
    });
  } catch (err) {
    console.error("chart capture failed", err);
    return null;
  }
};


const handleSaveReport = async () => {
  if (reportName.trim() === "") {
    alert("Please enter a report name before saving!");
    return;
  }


  const chartDataUrl = await serializeChartToPngDataUrl();

 
  const existing = JSON.parse(localStorage.getItem("savedReports")) || [];


  const currentUser = JSON.parse(localStorage.getItem("currentUser")) || { name: "Kiran Nandi" };

  const newReport = {
    id: Date.now(), 
    name: reportName,
    generatedBy: currentUser.name || "Unknown",
    createdAt: new Date().toLocaleString(),
    chartData: chartDataUrl, 
    campaigns: selectedData,
  };

  existing.push(newReport);
  localStorage.setItem("savedReports", JSON.stringify(existing));

  alert(`Report "${reportName}" saved successfully!`);
  setReportName("");
  // optionally close modal: onClose();
};



  return (
    <div className="create-new-campaign-modal-popup-overlay" onClick={onClose}>
      <div className="create-new-campaign-modal-popup-genrate-report-content" onClick={(e) => e.stopPropagation()}>
        <div className="create-new-campaign-modal-popup-genrate-report-header">
          <h2>📊 Generate Campaign Report</h2>
          <X size={24} className="create-new-campaign-modal-popup-genrate-report-close" onClick={onClose} />
        </div>

        <div className="create-new-campaign-modal-popup-genrate-report-body">
          {/* Left Section */}
          <div className="create-new-campaign-modal-popup-genrate-report-left">
            <h3>Select Campaigns</h3>
      

            <div className="create-new-campaign-modal-popup-genrate-report-campaign-list">
              {filtered.map((c) => (
                <label key={c.id} className="create-new-campaign-modal-popup-genrate-report-item">
                  <input
                    type="checkbox"
                    checked={selectedCampaigns.includes(c.id)}
                    onChange={() => toggleSelect(c.id)}
                  />
           <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
   
    {c.name}
    

    {c.platforms.includes("facebook") && 
        <i 
            className="fa-brands fa-facebook-f"
            style={{ fontSize: '14px', color: '#3b5998' }} 
            title="Facebook" 
        ></i>
    }
    
    {c.platforms.includes("instagram") && 
        <i 
            className="fa-brands fa-instagram" 
            style={{ fontSize: '14px', color: '#c32aa3' }} 
            title="Instagram" 
        ></i>
    }
    
    {c.platforms.includes("linkedin") && 
        <i 
            className="fa-brands fa-linkedin-in" 
            style={{ fontSize: '14px', color: '#0077b5' }} 
            title="LinkedIn" 
        ></i>
    }
</div>
                </label>
              ))}
            </div>

            <button className="create-new-campaign-modal-popup-genrate-report-submit-btn" onClick={handleSubmit}>
              Submit
            </button>
          </div>

          {/* Right Section */}
          <div className="create-new-campaign-modal-popup-genrate-report-right">
            {submitted && selectedData.length > 0 ? (
              <>
                <h3>Comparison Summary</h3>
                <table className="create-new-campaign-modal-popup-genrate-report-table">
                  <thead>
                    <tr>
                      <th>Campaign</th>
                      <th>Spend ($)</th>
                      <th>Budget ($)</th>
                      <th>Clicks</th>
                      <th>Conversions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedData.map((c) => (
                      <tr key={c.id}>
                        <td>{c.name}</td>
                        <td>{c.spend.toLocaleString()}</td>
                        <td>{c.budget.toLocaleString()}</td>
                        <td>{c.clicks.toLocaleString()}</td>
                        <td>{c.conversions.toLocaleString()}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div className="create-new-campaign-modal-popup-genrate-report-chart">
                  <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={selectedData}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" />
                      <YAxis />
                      <Tooltip />
                      <Legend />
                      <Bar dataKey="spend" fill="#8884d8" name="Spend" />
                      <Bar dataKey="conversions" fill="#82ca9d" name="Conversions" />
                    </BarChart>
                  </ResponsiveContainer>
                </div>

              <div className="create-new-campaign-modal-popup-genrate-report-save-section">
                <input
                  type="text"
                  className="create-new-campaign-modal-popup-genrate-report-input"
                  placeholder="Enter Report Name"
                  value={reportName}
                  onChange={(e) => setReportName(e.target.value)}
                />
              <button
                className="create-new-campaign-modal-popup-genrate-report-save-btn"
                onClick={handleSaveReport}
              >
                Save Report
              </button>

              </div>

              </>
            ) : (
              <p className="create-new-campaign-modal-popup-genrate-report-no-data">
                Select campaigns and click “Submit” to view comparison.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>

  );
};

// ---------------- Main Component ----------------
const Facebookcampaign = () => {
  const navigate = useNavigate();
  const [platform, setPlatform] = useState("All");
  const [status, setStatus] = useState("All");
  const [dateRange, setDateRange] = useState("Last 30 Days");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [reportModal, setReportModal] = useState(false);
const [selectedAccount, setSelectedAccount] = useState("");
const [facebookAccounts, setFacebookAccounts] = useState([
  { id: "123456789", name: "Kiran Marketing" },
  { id: "987654321", name: "Brand Boosters" },
  { id: "567890123", name: "Growth Media" },
]);
  const filteredCampaigns = campaignsData.filter((c) => {
    const platformMatch = platform === "All" || c.platforms.includes(platform.toLowerCase());
    const statusMatch = status === "All" || c.status === status;
    return platformMatch && statusMatch;
  });

  const handleViewDetails = (campaign) => {
    setSelectedCampaign(campaign);
    setIsModalOpen(true);
  };

  return (
    <div>
      {isModalOpen && selectedCampaign && (
        <CampaignDetailModal campaign={selectedCampaign} onClose={() => setIsModalOpen(false)} />
      )}
      {reportModal && <GenerateReportModal campaigns={campaignsData} onClose={() => setReportModal(false)} />}

      <div className="create-new-campaign-container">
        <div className="create-new-campaign-header">
  <p className="create-new-campaign-subtitle">Here’s an overview of your campaigns.</p>

  {/* ✅ New Dropdown for Facebook Accounts */}
  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
    <select
      className="create-new-campaign-dropdown"
      value={selectedAccount}
      onChange={(e) => setSelectedAccount(e.target.value)}
      style={{ width: "180px" }}
    >
      <option value="">Select Account</option>
      {facebookAccounts.map((acc) => (
        <option key={acc.id} value={acc.id}>
          {acc.name}
        </option>
      ))}
    </select>

    <button className="create-new-campaign-btn" onClick={() => setReportModal(true)}>
      <Plus size={18} /> Generate Report
    </button>
  </div>
</div>

       
        <div className="create-new-campaign-filters">
          <select className="create-new-campaign-dropdown" value={platform} onChange={(e) => setPlatform(e.target.value)}>
            <option value="All">Platform: All</option>
            <option value="facebook">Facebook</option>
            <option value="instagram">Instagram</option>
            <option value="linkedin">LinkedIn</option>
          </select>
          <select className="create-new-campaign-dropdown" value={status} onChange={(e) => setStatus(e.target.value)}>
            <option value="All">Status: All</option>
            <option value="Active">Active</option>
            <option value="Paused">Paused</option>
            <option value="Completed">Completed</option>
          </select>
          <select className="create-new-campaign-dropdown" value={dateRange} onChange={(e) => setDateRange(e.target.value)}>
            <option>Last 7 Days</option>
            <option>Last 30 Days</option>
            <option>Last 3 Months</option>
          </select>
        </div>

        {/* Campaign Cards */}
        <div className="create-new-campaign-grid">
          {filteredCampaigns.map((c) => (
            <div key={c.id} className="create-new-campaign-card">
              <div className="create-new-campaign-card-header">
                <h4 className="campaign-name-title">{c.name}</h4>
                <BarChart2 size={18} className="campaign-details-icon" onClick={() => handleViewDetails(c)} />
              </div>
              <div className="create-new-campaign-status-row">
                <span className="create-new-campaign-status active"></span>
                <span className="create-new-campaign-status-text">{c.status}</span>
              </div>
           <div className="create-new-campaign-platforms">
    
    {c.platforms.includes("facebook") && 
        <div className="create-new-campaign-icon-circle fb">
            <i className="fa-brands fa-facebook-f" style={{ fontSize: '14px' }}></i>
        </div>
    }
    
   
    {c.platforms.includes("linkedin") && 
        <div className="create-new-campaign-icon-circle li">
            <i className="fa-brands fa-linkedin-in" style={{ fontSize: '14px' }}></i>
        </div>
    }
    

    {c.platforms.includes("instagram") && 
        <div className="create-new-campaign-icon-circle ig">
            <i className="fa-brands fa-instagram" style={{ fontSize: '14px' }}></i>
        </div>
    }
</div>
              <div className="create-new-campaign-info">
                <p>Spend: <strong>${c.spend.toLocaleString()}</strong> / ${c.budget.toLocaleString()}</p>
                <p>Conversions</p>
              </div>
              <div className="create-new-campaign-progress">
                <div className="create-new-campaign-progress-bar" style={{ width: `${(c.spend / c.budget) * 100}%` }}></div>
              </div>
              <div className="create-new-campaign-footer">
                <span>Clicks: {c.clicks.toLocaleString()}</span>
                <span>{c.conversions} conversions</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default Facebookcampaign;